<div class="create-role">
    <!-- Form Container -->
    <div class="container-custom">
        <div class="d-flex justify-content-between align-items-center">
            <div>
             <app-breadcrumb [breadcrumbItems]="breadcrumbItems"></app-breadcrumb>
            </div>
            <span class="fa fa-times close_icon" (click)="closeModal()"></span>
        </div>
        <div class="d-flex justify-content-between align-items-center role-header">
            <div>
                <span class="title">Create Global Tag</span>
            </div>
        </div>
        <div class="my-4">
            <p>Please fill the below information to create a global tag.</p>
        </div>
        <!-- Form Fields -->
        <form [formGroup]="globalTagForm" (ngSubmit)="onSubmit()">
            <div class="row g-3">
                <div class="col-md-12">
                    <label class="form-label">Enter Tag Name*</label>
                    <input type="text" class="form-control" placeholder="Enter Global Tag Name" formControlName="tag_name">
                    <small *ngIf="globalTagForm.get('tag_name')?.invalid && globalTagForm.get('tag_name')?.touched"
                        class="text-danger">
                        <span *ngIf="globalTagForm.get('tag_name')?.errors?.['required']">Global Tag name is
                            required.</span>
                        <span *ngIf="globalTagForm.get('tag_name')?.errors?.['maxlength']">Global Tag name cannot exceed
                            100 characters.</span>
                    </small>
                </div>
                <div class="col-md-12 mt-3">
                    <label class="form-label">Description*</label>
                    <app-markdown-editor formControlName="description" placeholder="Enter the tag description"></app-markdown-editor>
                    <small
                        *ngIf="globalTagForm.get('description')?.invalid && globalTagForm.get('description')?.touched"
                        class="text-danger">
                        <span *ngIf="globalTagForm.get('description')?.errors?.['required']">Description is
                            required.</span>
                    </small>
                </div>
            </div>

            <!-- Toggles -->
            <div class="mt-3">
                <div class="d-flex align-items-center mb-2">
                    <label class="form-check-label me-2">Deleted Status</label>
                    <div class="form-check form-switch">
                        <input class="form-check-input " type="checkbox" formControlName="deleted" >
                    </div>
                </div>
            </div>

            <div *ngIf="!globalTagData" class="save-another-wrapper mt-4">
                <button
                    class="btn btn-save-another"
                    type="button"
                    (click)="saveAndCreateAnother()">
                    Save and Create Another Tag
                </button>
            </div>

            <!-- Buttons -->
            <div class="footer-buttons mt-3">
                <div class="d-flex align-items-center mt-3 gap-3">
                    <button class="btn btn-outline-secondary mt-3" (click)="closeModal()" type="button">Cancel</button>
                    <button class="btn btn-create mt-3" type="submit">Save</button>
                </div>
            </div>
        </form>
    </div>
</div>
